import script from "./ElementShadow.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementShadow.vue?vue&type=script&lang=ts&setup=true"

import "./ElementShadow.vue?vue&type=style&index=0&id=053ed706&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-053ed706"]])

export default __exports__